module.exports = __webpack_public_path__ + "img/967b03a182ee2df8f51dbc08b8150959.png";